
const buttons = document.querySelectorAll('[data-share]');

// create an old school popup for the service's share dialog
function createPopup(url, name) {
    const screenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
    const screenTop = window.screenTop != undefined ? window.screenTop : screen.top;
    const width = 575;
    const height = 440;
    const left = screenLeft + ((window.innerWidth - width) / 2);
    const top = screenTop + ((window.innerHeight - height) / 2);
    const opts = `toolbar=no,menubar=no,location=no,personalbar=no,width=${width},height=${height},top=${top},left=${left}`;
    window.open(url, name, opts);
}

buttons.forEach(button => {
    button.addEventListener('click', event => {

        event.preventDefault();

        const url = event.target.href;
        const service = event.target.dataset['share'];

        if (!service && navigator.share) {
            navigator.share({
                url: window.location.href
            });
            return false;
        }

        if (!url) {
            return false;
        }

        createPopup(url, service);
        return false;
    });
});